module.exports = __webpack_public_path__ + "media/images/application2/AppPublisher__package__buttons__a-6d939b6abc3850946f98fe2607c4701d.svg";